import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppButton, FigmaTypography, InnoveraLoading } from "@libs/zapi-ui/custom";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";

export function SettingUpAnalysisScreen({ onBack }: { onBack?: () => void }) {
  const navigate = useNavigate();
  const { t } = useTranslation("projectHome");

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-2 w-[400px] rounded-[16px] bg-white px-8 py-10 shadow-[0px_18px_11px_0px_rgba(24,24,27,0.01),0px_8px_8px_0px_rgba(24,24,27,0.01),0px_2px_5px_0px_rgba(24,24,27,0.02)]">
        <InnoveraLoading size={48} />
        <FigmaTypography variant="heading-2" className="mt-4 text-center">
          {t("generation.settingUpTitle")}
        </FigmaTypography>
        <FigmaTypography variant="body-2" color="zinc500" className="text-center">
          {t("generation.settingUpDescription")}
          <br />
          {t("generation.settingUpEstimate")}
        </FigmaTypography>
        <AppButton
          appearance="outlined"
          color="zinc150"
          className="mt-4 text-innoveraZinc-900 shadow-none"
          onClick={() => (onBack ? onBack() : navigate(getRouteProjects()))}
        >
          {t("generation.backToProjectList")}
        </AppButton>
      </div>
    </div>
  );
}
